import PropTypes from 'prop-types'
import React from "react"
import { Col, Modal, ModalBody, Row, Spinner } from "reactstrap"
import { sendBrodcast } from '../../helpers/backend_helper'

const BroadcastModal = ({ show, onDeleteClick, onCloseClick,loading,typeList,setTypeList,title,description,setShow }) => {
const onClickType=(type)=>{
setTypeList(prev=>(prev.map(p=>p.type == type ? {...p,selected: p.selected ? false : true} : {...p})))
}

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <Row>
          <Col lg={12}>
            <div className="text-center">
              <h2>Before send</h2>
              <h4>{"Please select what type of user you want to send the broadcast"}</h4>
            </div>
          </Col>
        </Row>
        <Row>
          {loading ? (
             <div style={{width:'100%',display:'flex',justifyContent:'center'}}><Spinner type="grow" className="m-1 center" color="primary" /></div> 
          ) : (
           
           
               <Col>
               <div className="text-center mt-3">
                <button
                  type="button"
                  className={`btn  ${typeList[0].selected ? 'btn-primary' : 'btn-outline-primary'} btn-lg ms-2`}
                  onClick={()=>onClickType('guest_topic')}
                >
                  Guests
                </button>
                <button
                  type="button"
                  className={`btn  ${typeList[1].selected ? 'btn-primary' : 'btn-outline-primary'} btn-lg ms-2`}
                  onClick={()=>onClickType('client_topic')}
                >
                  Customers
                </button>
                <button
                  type="button"
                  className={`btn  ${typeList[2].selected ? 'btn-primary' : 'btn-outline-primary'} btn-lg ms-2`}
                  onClick={()=>onClickType('vendor_topic')}
                >
                  Providers
                </button>
              </div>
              <Row>
              <div className="text-center mt-3">
                <button
                  type="button"
                  className="btn btn-primary btn-lg ms-2"
                  onClick={()=>{sendBrodcast({title,description,topics:typeList.filter(t=>t.selected == true).map(t=>t.type)});setShow(false);console.log(typeList.filter(t=>t.selected == true).map(t=>t.type))}}
                >
                  Send
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-lg ms-2"
                  onClick={()=>setShow(false)}
                >
                  Cancel
                </button>
              
              
              </div>
              </Row>
            </Col>
            
           
              
            
          )}
        </Row>
      </ModalBody>
    </Modal>
  )
}

BroadcastModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any
}

export default BroadcastModal
